var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-button-control"},[_c('div',{staticClass:"switch-button-label text-left align-self-start"},[_vm._t("default")],2),_c('div',{staticClass:"switch-button align-self-center",class:{ 'enabled': _vm.isEnabled },on:{"click":_vm.toggle}},[_c('div',{staticClass:"button"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }